import {
  PropsWithTheme,
  OwnUpGridWrapper,
  OwnUpHeadlineBook
} from '@rategravity/own-up-component-library';
import styled from 'styled-components';

export const CTAButton2Wrapper = styled(OwnUpGridWrapper)`
  border: 1px solid #84cdaa;
  border-radius: 8px;
  padding: 20px 0 40px;
  text-align: center;
  margin-bottom: 40px;
  margin-left: 0px;
  margin-right: 0px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    padding: 24px 16px;
  }
`;

export const CTARatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('xs')} {
    flex-direction: column;
  }
`;

export const CTARatingIconItem = styled.div`
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('xs')} {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

export const CTARatingNumbersItem = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('xs')} {
    padding-left: 0px;
  }
`;

export const CTAHeadlineWrapper = styled.div``;

export const CTAHeadlineText = styled(OwnUpHeadlineBook)`
  font-size: 40px;
  padding-bottom: 0px;
  padding-top: 20px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    padding-bottom: 0px;
    padding-top: 0px;
    font-size: 30px;
  }
`;

export const CTAButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing(2)}px;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-top: ${({ theme }) => theme.spacing(5)}px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: ${({ theme }) => theme.spacing(4)}px;
  }
`;

export const CTAButtonLink = styled.a`
  color: ${({ theme }: PropsWithTheme<{}>) => theme.underlineLinkColors.linkFontColor};
  text-decoration: none;
`;
